/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockMasterItems
 */
angular.module('mercury.modules.stock.item')
.factory('StockMasterItems', ["$q", "$resource", "settings", function($q, $resource, settings) {
  var StockMasterItems = $resource(settings.apiHost + '/r/StockMasterItems');

  // Manage the string search so only one request is active at once
  var pendingSearch = false;
  var pendingPromise = null;
  var nextSearch = false;

  /**
   * [getAllByItemGroup description]
   *
   * @memberof StockMasterItems
   * @param  {?} itemGroupId [description]
   * @return {?}             [description]
   */
  function getAllByItemGroup(itemGroupId) {
    var params = {
      $filter: 'GroupId eq ' + itemGroupId
    };

    return StockMasterItems.query(params).$promise;
  }

  /**
   * [getAllBySearchString description]
   *
   * @memberof StockMasterItems
   * @param  {?} searchString [description]
   * @return {?}              [description]
   */
  function getAllBySearchString(searchString) {
    if (pendingSearch) {
      // Store the latest search parameter so we can make another request once
      // this one completes
      nextSearch = searchString;
      return pendingPromise.promise;
    } else {
      pendingSearch = true;
      pendingPromise = $q.defer();

      var params = {
        $filter: 'contains(tolower(Name), tolower(\'' + searchString.replace(/\'/g, '\'\'') + '\'))'
      };

      StockMasterItems.query(params).$promise
      .then(function(response) {
        pendingSearch = false;
        if (nextSearch !== false) {
          // If another search was requested before this one completed, chain the promise
          // with the next search parameter
          pendingPromise.resolve(getAllBySearchString(nextSearch));
        } else {
          // No other pending search so just resolve with the response.
          pendingPromise.resolve(response);
        }
        nextSearch = false;
      }, function(response) {
        nextSearch = false;
        pendingSearch = false;
        pendingPromise.reject(response);
      });

      return pendingPromise.promise;
    }
  }

  return {
    getAllByItemGroup: getAllByItemGroup,
    getAllBySearchString: getAllBySearchString
  };
}]);
